module.exports = __webpack_public_path__ + "img/imgs-item-6.c5ea75b5.png";